
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(48|574|583|751|989)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
